const artists = [
  {
    id: 1,
    name: "Elgrandetoto",
    image: "https://i.scdn.co/image/ab676161000051743356d76683fee723537247f1",
    genre: "hip hop",
    streams_count: 3668081,
    search_count: 100,
    bio: "A short bio about the artist.",
    type: "Artist",
  },
  {
    id: 2,
    name: "Sia",
    image: "https://i.scdn.co/image/ab67616d00001e02754b2fddebe7039fdb912837",
    genre: "pop",
    streams_count: 1508759386,
    bio: "A short bio about the artist.",
    search_count: 100,
    type: "Artist",
  },
  {
    id: 3,
    name: "Metro Boomin",
    streams_count: 48586067,
    image: "https://i.scdn.co/image/ab67616100005174df9a1555f53a20087b8c5a5c",
    bio: "A short bio about the artist.",
    genre: "pop",
    search_count: 100,
    type: "Artist",
  },
  {
    id: 4,
    name: "Lil Uzi Vert",
    streams_count: 123456,
    image: "https://i.scdn.co/image/ab6761670000ecd440a553dda32ff20c59707da4",
    bio: "A short bio about the artist.",
    genre: "hip hop",
    search_count: 100,
    type: "Artist",
  },
];

const getPopularArtistsByGenre = (genre) => {
  const searchGenre = genre.split('-').join(' ');
  return artists
    .filter((artist) => artist.genre === searchGenre)
    .sort((a, b) => b.streams_count - a.streams_count)
    .slice(0, 10);
};

const getArtistById = (id) => {
  return artists.find((artist) => artist.id === id);
};

const getRelatedArtists = (artistId) => {
  const artist = artists.find((a) => a.id === artistId);
  
  if (!artist) {
    throw new Error(`Artist with ID ${artistId} not found.`);
  }

  return artists
    .filter((a) => a.genre === artist.genre && a.id !== artistId)
    .sort((a, b) => b.streams_count - a.streams_count)
    .slice(0, 10);
};

const getPopularArtistsByStreams = () => {
  return artists
    .sort((a, b) => b.streams_count - a.streams_count)
    .slice(0, 12);
};

const getPopularArtistsBySearchCount = () => {
  return artists
    .sort((a, b) => b.search_count - a.search_count)
    .slice(0, 12);
};

const searchArtistsByValue = (value, limit = 12) => {
  return artists
    .filter((item) => item.name.toLowerCase().includes(value.toLowerCase()))
    .sort((a, b) => b.streams_count - a.streams_count)
    .slice(0, limit);
};

export {
  getArtistById,
  getRelatedArtists,
  getPopularArtistsByGenre,
  getPopularArtistsByStreams,
  getPopularArtistsBySearchCount,
  searchArtistsByValue,
};